<template>
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
              name="Settlement"
              bc1="App"
              bc2="Direct"
              bc3="Detail"
          ></Breadcrumb>
        </div>
        <div
            class="content-header-right text-md-right col-md-3 col-12 d-md-block d-none"
        >
        </div>
      </div>
      <div class="content-body">
        <!-- users list start -->
        <section class="app-user-list">
          <section id="alerts-with-title">
            <div class="row">
              <div class="col-sm-12">
                <div class="card">
                  <div class="card-header">
                    <h4 class="card-title"><img width="150" :src="`${publicPath}vaults-authlogo.png`"></h4>
                    <button type="button" class="justify-content-end btn btn-danger btn-sm" @click="backTo">Back</button>
                  </div>
                  <div class="card-body">
                    <div class="row">
                      <div class="col-5">
                        <h6 class="mb-1 text-primary"><span class="text-dark font-weight-bolder">Merchant : </span>{{merchantName}}
                        </h6>
                        <h6 class="mb-1 text-primary"><span class="text-dark font-weight-bolder">Email : </span>{{merchantEmail}}
                        </h6>
                        <div class="row">
                          <div class="col-6">
                            <input type="text" class="form-control" placeholder="search" v-model="search" />
                          </div>
                          <div class="col-6">
                            <button class="btn btn-success btn-sm " @click="submitSearch" type="button">Submit</button>
                            <button class="btn btn-dark btn-sm ml-1 " type="button" @click="clearSearch">Clear</button>
                          </div>

                        </div>
                      </div>
                      <div class="col-7">
                        <h6 class="mb-1 text-primary"><span class="text-dark font-weight-bolder">Settlement ID#</span>
                          {{merchantSettlementId}}</h6>
                        <h6 class="mb-1 text-primary"><span class="text-dark font-weight-bolder">Date Created</span>
                          {{new Date(merchantSettlementCreatedAt).toDateString()}}</h6>
                        <h6 v-if="merchantSettlementStatus == 1" class="mb-1 text-danger"><span class="text-dark font-weight-bolder">Status:  </span> <div class="badge   badge-glow badge-info mt-1">INITIATED</div></h6>
                        <h6 v-else-if="merchantSettlementStatus == 2" class="mb-1 text-danger"><span class="text-dark font-weight-bolder">Status:  </span><div class="badge   badge-glow badge-danger mt-1">CANCELED</div></h6>
                        <h6 v-else-if="merchantSettlementStatus == 3" class="mb-1 text-danger"><span class="text-dark font-weight-bolder">Status:  </span><div class="badge   badge-glow badge-success mt-1">DONE</div></h6>
                        <h6 v-else class="mb-1 text-danger"><span class="text-dark font-weight-bolder">Status:  </span><div class="badge   badge-glow badge-warning mt-1">PENDING</div></h6>
                        <!--                        <h6 class="mb-1 text-primary"><span class="text-dark font-weight-bolder">Total Amount:  </span>{{parseFloat(merchantSettlementAmount/100).toFixed(3)}} <div class="badge badge-light-success ">{{merchantSettlementCurrency}}</div></h6>-->
                        <h6 class="mb-1 text-primary"><span class="text-dark font-weight-bolder">Total Transactions:  </span>{{merchantSettlementTotalRecords}}</h6>
                      </div>
                    </div>
                    <div class="row mt-5">
                      <div class="col-12">
                        <div class="card">
                          <CommonTable
                              :url="url"
                              :tableHeaderValues="tableHeaderValues"
                              :actions="actions"
                              :deleteActions="deleteActions"
                              :mutedData="mutedData"
                              :storageKey="storageKey"
                              :externalTotalRecord="externalTotalRecord"
                              :filteredData="filteredData"
                              @getFullResponse="getFullResponse"
                              forceStartPerPageForPagination="50"
                              :exportData="exportData"
                              :hidePdfExportButton="true"

                          />
                          <div class="card-body mt-5">
                            <div class="row">
                              <div class="col-7"></div>
                              <div class="col-5 bg-light-warning ">
                                <div class="row p-2 border-warning badge-glow">
                                  <div class="col-6 mt-1">
                                    <h6 class="mb-2 text-primary"><span class="text-dark font-weight-bolder">Amount:</span></h6>
                                    <h6 class="mb-2 text-primary"><span class="text-dark font-weight-bolder">Vat:</span></h6>
                                    <h6 class="mb-2 text-primary"><span class="text-dark font-weight-bolder">Fee:</span></h6>
                                    <h6 class="mb-2 text-primary"><span class="text-dark font-weight-bolder">Settlement Amount:</span></h6>
                                  </div>
                                  <div class="col-2"></div>
                                  <div class="col-4">
                                    <h6 class="mb-2 text-primary">{{parseFloat(merchantSettlementAmount/100).toFixed(amountDecimalPlaces)}} <div class="badge badge-light-success ">{{merchantSettlementCurrency}}</div></h6>
                                    <h6 class="mb-2 text-primary">{{parseFloat(merchantSettlementVat/100).toFixed(feesDecimalPlaces)}} <div class="badge badge-light-success ">{{merchantSettlementCurrency}}</div></h6>
                                    <h6 class="mb-2 text-primary">{{parseFloat(merchantSettlementFees/100).toFixed(feesDecimalPlaces)}} <div class="badge badge-light-success ">{{merchantSettlementCurrency}}</div></h6>
                                    <h6 class="mb-2 text-primary">{{parseFloat((parseFloat(merchantSettlementAmount)-parseFloat(merchantSettlementVat)-parseFloat(merchantSettlementFees))/100).toFixed(amountDecimalPlaces)}} <div class="badge badge-light-success ">{{merchantSettlementCurrency}}</div></h6>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

        </section>
        <!-- users list ends -->

      </div>
    </div>
  </div>
</template>

<script>


export default {
  props: ['propFilters'],
  mounted() {
    let mainSettlementData = this.$store.getters.getByKey(
        "mainSettlementData"
    );

    this.merchantName = mainSettlementData.row.user_account.user.first_name
    this.merchantEmail = mainSettlementData.row.user_account.user.email
    this.merchantSettlementId = mainSettlementData.row.uuid
    this.merchantSettlementStatus = mainSettlementData.row.status
    this.merchantSettlementAmount = mainSettlementData.row.amount
    this.merchantSettlementVat = mainSettlementData.row.vat
    this.merchantSettlementFees = mainSettlementData.row.fee
    this.merchantSettlementCreatedAt = mainSettlementData.row.created_at
    this.merchantSettlementCurrency = mainSettlementData.row.user_account.currency.code

    localStorage.setItem("url", "v1/get-settlement");
    this.checkDataInStore('v1/get-settlement')
    if (
        typeof this.$route.params.update == "undefined" &&
        typeof this.$route.params.add == "undefined"
    ) {
      this.$store.dispatch("set", null);
    }

  },
  data() {
    return {
      exportData:{
        cta: (exportType) => {
          let requestData = {
            exportAs: exportType,
            reportType: 'settlement',
            // type: 1,
            // settlementId:this.$route.params.id,
            ...this.filteredData,
            // search: this.search,
            // type: 1,
            // settlementId:this.$route.params.id,

            /*new filter approach start*/
            id: this.$route.params.id,
            type:'direct',
            settlementStatus:this.$route.params.settlementStatus,
            transactionType: 'in',
            search: this.search
            /*new filter approach end*/
          }


          this.downloadReport(requestData)
        }
      },
      search:'',
      merchantName:'',
      merchantEmail:'',
      merchantSettlementId:'',
      merchantSettlementStatus:'',
      merchantSettlementAmount:'',
      merchantSettlementVat:'',
      merchantSettlementFees:'',
      merchantSettlementCreatedAt:'',
      merchantSettlementCurrency:'',
      merchantSettlementTotalRecords:'',
      settlementData : [],
      totalAmount: 0,
      vat: 0,
      fee: 0,
      currency: '',
      url: "v1/get-settlement",
      storageKey: "direct-settlement-detail",
      status: "",
      filteredData: {id: this.$route.params.id,type:'direct',settlementStatus:this.$route.params.settlementStatus,transactionType: 'in'},
      tableHeaderValues: [
        {
          title: 'Transaction Id',
          valueKey: 'uuid',
          html: true,
          alter: function (value) {
            var html = ''
            if (value)
              html = `<span class="text-primary"  style="cursor: pointer" >${value}</span>`


            return html


          },
          cta: (row) => {
            this.$router.push({name: 'transactions-detail',params: {id:row.uuid}})
          }
        },
        {
          title: 'Gateway Reference',
          valueKey: 'gateway_reference_id',
          html: true,
          alter: function (value) {
            var html = ''
            if (value)
              html = `<span class="text-info">${value}</span>`


            return html


          }
        },
        {
          title: 'Reference Id',
          valueKey: 'reference_id',
          html: true,
          alter: function (value) {
            var html = ''
            if (value)
              html = `<span class="text-danger">${value}</span>`


            return html


          }
        },
        {
          title: 'Card No',
          valueKey: 'sender_account_number',
          html: true,
          alter: function (value) {
            var html = ''
            if (value)
              html = `<span class="text-success">${value}</span>`


            return html


          }
        },
        {
          title: 'Sender',
          valueKey: 'sender_account_title',
          html: true,
          alter: function (value) {
            var html = ''
            if (value)
              html = `<span class="text-primary">${value}</span>`


            return html


          }
        },
        {
          title: 'Sender Email',
          valueKey: 'sender.email',
          html: true,
          alter: function (value) {
            var html = ''
            html = ` <a href="javascript:void()" class="badge badge-glow badge-dark">${value}</a>`

            return html


          }
        },
        {
          title: 'Receiver Email',
          valueKey: 'receiver.email',
          html: true,
          alter: function (value) {
            var html = ''
            html = ` <a href="javascript:void()" class="badge badge-glow badge-dark">${value}</a>`

            return html


          }
        },
        {
          title: 'Channel',
          valueKey: 'channel',
          html: true,
          alter: function (value) {
            // Show the channel name when the transaction carries a channel object
            return value && value.name
                ? `<p class="text-primary mb-0">${value.name}</p>`
                : '-'
          }
        },
        {
          title: 'Amount',
          valueKey: 'amount',
          html: true,
          alter:  (value, row) => {
            var html = ''

            html = ` <div  class="  text-dark">${this.modifyAmount(parseFloat(value / 100).toFixed(this.amountDecimalPlaces))}</div>`


            return html
          }
        },
        {
          title: 'Vat',
          valueKey: 'vat',
          html: true,
          alter:  (value, row) => {
            var html = ''

            html = ` <div  class="  text-dark">${parseFloat(value / 100).toFixed(this.feesDecimalPlaces)}</div>`


            return html
          }
        },
        {
          title: 'Fees',
          valueKey: 'fee',
          html: true,
          alter:  (value, row) => {
            var html = ''

            html = ` <div  class="  text-dark">${parseFloat(value / 100).toFixed(this.feesDecimalPlaces)}</div>`


            return html

          }
        },
        {
          title: 'Payable Amount',
          valueKey: 'amount',
          html: true,
          customClass: 'text-center',
          alter: (value,row) => {
            var html=''
            if(value){
              if(row.transaction_type_id == 6){
                html = `<span style="font-size: larger" class=" font-weight-bolder text-danger row justify-content-center">- ${this.modifyAmount(parseFloat((parseFloat(value)+parseFloat(row.vat)+parseFloat(row.fee))/100).toFixed(this.amountDecimalPlaces))}</span>
                <div class="badge badge-light-success mt-1">Refunded</div>`
              }
              else if((row.transaction_type_id == 11 || row.transaction_type_id == 15) &&  this.$store.getters.getByKey("mainSettlementData").row.user_account_id == row.sender_account_id ){
                html = `<span style="font-size: larger" class=" font-weight-bolder text-danger row justify-content-center">- ${this.modifyAmount(parseFloat((parseFloat(value)+parseFloat(row.vat)+parseFloat(row.fee))/100).toFixed(this.amountDecimalPlaces))}</span>
                <div class="badge badge-light-primary mt-1">${row.transaction_type_id == 11 ? 'Adjusted' : 'R-Reserved'}</div>`
              }
              else{

                html = `<span style="font-size: larger" class=" font-weight-bolder text-dark">${this.modifyAmount(parseFloat((value - row.vat - row.fee)/100).toFixed(this.amountDecimalPlaces))}</span>`

              }
            }


            return  html


          },
        },
        {
          title: 'Schema',
          valueKey: 'schema',
          html: true,
          alter:  (value,row) => {
            var html = ''
            if (value)
              html = ` <a href="javascript:void()" class="badge badge-glow badge-info">${row.schema.name}</a>`
            else
              html = `N/A`

            return html


          }
        },
        {
          title: 'Transaction Type',
          valueKey: 'transaction_type.name',
          html: true,
          alter: function (value) {
            var html = ''
            if (value)
              html = ` <a href="javascript:void()" class="badge badge-glow badge-success">${value}</a>`


            return html


          }
        },
        {
          title: 'Transaction Time/Date',
          titleHtml: `<span class="text-warning font-weight-bolder">
														(Showing In GMT)
													</span>`,
          valueKey: "created_at",
          html: true,
          alter: (value,row) => {
            var html='-'
            if(value)
              html = ` <div  class=" font-weight-bolder text-dark">${new Date(value).toISOString().slice(0, 16).replace('T', ' ')}</div>`



            return  html


          }
        },
      ],
      actions: [],
      deleteActions: [],
      mutedData: [],
      externalTotalRecord: "",

    }
  },
  methods: {
    submitSearch(){
      this.filteredData = {
        ...this.filteredData,
        search: this.search
      }
    },
    clearSearch(){
      let temp = this.filteredData;
      delete temp["search"]
      this.filteredData={
        ...temp
      }
      this.search = ''
    },
    backTo(){
      let propFilters = this.propFilters
      if(this.$route.params.settlementStatus == 'initiated'){
        this.$router.push({name:'direct-settlements',query: { tab: 1 },params:{propFilters}})
      }else if(this.$route.params.settlementStatus == 'canceled'){
        this.$router.push({name:'direct-settlements',query: { tab: 2 },params:{propFilters}})
      }else{
        this.$router.push({name:'direct-settlements',query: { tab: 3 },params:{propFilters}})
      }
    },
    getFullResponse(response) {
      if (typeof (response.fullResponse) != 'undefined') {
        let data = response.fullResponse
        this.merchantSettlementTotalRecords = data.paginationData.total

        // if(typeof(data.charges) != 'undefined'){
        //
        // }
      }
    },
    sendCall() {
      this.makeRequest('post', 'v1/get-settlement', {id: this.$route.params.id,type:'direct'}, {}, false).then(callResponse => {

        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code == 200) {
            this.settlementData = callResponse.response.data.data
          }
        }

      });

    },
  },

}
</script>


